export default "__VITE_ASSET__Uuf4B$2q__"